<template>
    <div class="extranarrowcol">
        <slot />
    </div>
</template>
